import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import styles from './MobileHomeWeather.module.scss'
import moment from 'moment';
import client from '@/lib/feathers';

const MobileHomeWeather = () => {
  const communityData = client.service('communityData');
  const [icon, setIcon] = useState('01d');
  const [temp, setTemp] = useState(null);
  const bToday = '今天';
  // console.log("icon:", icon)
  // console.log("temp:", temp)
  const updatetime = useRef();
  function updateData() {
  
    const sTime = moment().format('YYYYMMDDHH');
    if (updatetime.current === sTime) return;
    updatetime.current = sTime;
   
    communityData.find({}).then((res) => {
      console.log('==find communityData data success', res.data)
      // setCommunity(res.data[0].city)
      let sCity = res.data[0].city ?res.data[0].city : '台北市';
      axios(`/ezcon/api/getWeather?city=${sCity}`, {
        method: 'GET',
  
      }).then((res) => {
        console.log('==get weather success:', res.data);
        if (res.data) {
          console.log('==', moment().format('HH:mm:ss 更新天氣'));
          if (bToday) { // 今天
            if (res.data.今天.現在氣溫) {
              setTemp(Math.round(res.data.今天.現在氣溫));
            }
            if (res.data.今天.圖示) {
              setIcon(res.data.今天.圖示);
            }
          } else { // 明天
            if (res.data.明天.白天氣溫) {
              setTemp(Math.round(res.data.明天.白天氣溫));
            }
            if (res.data.明天.圖示) {
              setIcon(res.data.明天.圖示);
            }
          }
        }
  
      }).catch((error) => {
        console.log('==get weather fail:', error);
  
  
      })
  
    }).catch(err => {
      console.log('==find communityData data fail', err)
    });




    

  }

  useEffect(() => {
    updateData();
  },[]);
 



  return (
    <>
      
      <img className={styles.weatherIcon} src={`天氣Icon/${icon}.svg`} />
      <p  className={styles.temp}>{`${temp}°C`}</p>

    </>);
}

export default MobileHomeWeather;
